import React from 'react';
import { invert } from 'lodash';

import { isMobile } from 'components/DiamondList/DiamondListFunctions';
import { formatNumber, calculate } from './SelectStone';

export function HeadingCalc(checked, VALUES = null) {
  if (isMobile() && !checked.length && !VALUES) return null;
  let obj = {};
  if (VALUES) {
    obj = VALUES;
  } else {
    let sum = calculate(checked);
    obj = {
      'CT. :': parseFloat(sum.total_carat),
      'Disc% :': parseFloat(sum.final_discount),
      'Price/Ct :': formatNumber(parseFloat(sum.final_price)),
      'Total Value :': formatNumber(parseFloat(sum.final_value)),
    };
  }
  if (isMobile()) obj = invert(obj);
  if (Object.keys(obj).length < 4) return null;
  return (
    <div className="DiamondDetailPopup">
      {Object.keys(obj).map((x) => {
        return (
          <div key={x} className="DiamondDetailPopupItem" style={VALUES ? checked : {}}>
            <span>{x}</span>
            <span>{isMobile() ? obj[x].slice(0, obj[x].length - 1) : obj[x]}</span>
          </div>
        );
      })}
    </div>
  );
}
